import { useSelector } from "react-redux";
const SelfServiceGetters = {
  getIsAvailable() {
    return useSelector((state) => state.selfService.isAvailable);
  },
};
export { SelfServiceGetters };
